import React from 'react';
export function StrategySection() {
  const steps = [{
    number: '01',
    title: 'Evaluation & Offer',
    description: 'We conduct a discreet, professional evaluation of your business and present a fair, market-based offer within days.'
  }, {
    number: '02',
    title: 'Due Diligence',
    description: 'Our team verifies financials and equipment condition efficiently, respecting your time and confidentiality.'
  }, {
    number: '03',
    title: 'Closing & Transfer',
    description: 'We handle all paperwork and logistics for a seamless transfer of ownership, releasing your funds immediately.'
  }, {
    number: '04',
    title: 'Optimization',
    description: 'We implement our proprietary management systems, upgrade technology, and enhance marketing to drive growth.'
  }];
  return <section id="strategy" className="py-16 sm:py-20 lg:py-24 bg-[#0f2424] relative overflow-hidden" data-id="element-186">
      {/* Decorative background line */}
      <div className="absolute top-0 left-1/2 w-px h-full bg-gradient-to-b from-transparent via-[#4fd1c5]/20 to-transparent hidden lg:block" data-id="element-187"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-188">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-12 lg:gap-16 items-start" data-id="element-189">
          {/* Left Column: Header */}
          <div className="lg:sticky lg:top-32 text-center lg:text-left" data-id="element-190">
            <h2 className="text-xs sm:text-sm font-semibold text-[#4fd1c5] tracking-widest uppercase mb-3" data-id="element-191">
              Our Strategy
            </h2>
            <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 sm:mb-6" data-id="element-192">
              A Proven Process for <br className="hidden sm:block" data-id="element-193" />
              Seamless Acquisition
            </h3>
            <p className="text-gray-400 text-base sm:text-lg leading-relaxed" data-id="element-194">
              We've streamlined the acquisition process to minimize disruption
              to your business. Our approach is transparent, efficient, and
              designed to give owners peace of mind.
            </p>
          </div>

          {/* Right Column: Steps */}
          <div className="space-y-8 sm:space-y-12" data-id="element-195">
            {steps.map((step, index) => <div key={index} className="flex gap-4 sm:gap-6 group" data-id="element-196">
                <div className="flex-shrink-0" data-id="element-197">
                  <span className="text-4xl sm:text-5xl font-bold text-[#4fd1c5]/20 group-hover:text-[#4fd1c5] transition-colors duration-300 font-mono" data-id="element-198">
                    {step.number}
                  </span>
                </div>
                <div className="pt-1 sm:pt-2" data-id="element-199">
                  <h4 className="text-lg sm:text-xl font-bold text-white mb-2 sm:mb-3 group-hover:text-[#4fd1c5] transition-colors" data-id="element-200">
                    {step.title}
                  </h4>
                  <p className="text-sm sm:text-base text-gray-400 leading-relaxed" data-id="element-201">
                    {step.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}